import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { Box, Button, Divider, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import { SkipNumbers } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/smartInbox/ui/SkipNumbers/SkipNumbers'
import styles from './styles.module.scss'

export const SmartInbox = observer(() => {
  const { id } = useParams()
  const {
    inboxSettingsStore: { smartInboxStore },
    inboxesViewStore,
  } = useInboxLayerContext()
  const {
    localmsg,
    toggleLocalmsg,
    shouldShowAddNumberFlow,
    isUserCanManageOrganizationInboxes,
    multiSelectedValues,
    search,
    setSearch,
    numbersGroups,
    handleMultiSelect,
    removeMultiSelectedItem,
    updateDeprioritizeNumbers,
  } = smartInboxStore

  const handleAddNumbers = () => {
    if (!id) return

    inboxesViewStore.inboxesStore.manageNumberWrapper(() => {
      uiStore.changeRoute({
        path: `${InboxesPath.inboxNumbersAddNumber(Number(id))}`,
      })
    })
  }

  return (
    <div className={styles.wrap}>
      <Typography ariaLabel={'SmartInboxTitle'} variant={'body-lg-medium'} marginBottom={'32px'}>
        Smart inbox
      </Typography>
      <DoubleOptInSettingLayout
        title={'Localmsg'}
        description={'Sends messages from numbers in the same area code as recipients'}
        checked={localmsg}
        onToggle={toggleLocalmsg}
        disabled={shouldShowAddNumberFlow}
      />
      {isUserCanManageOrganizationInboxes && (
        <>
          <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={'4px'}
              flex={1}
              marginTop={'16px'}
              maxWidth={'351px'}
            >
              <Typography
                ariaLabel='title'
                variant='body-md-medium'
                color='var(--content-primary-primary)'
              >
                Skip numbers
              </Typography>
              <Typography
                ariaLabel='description'
                variant='body-md-regular'
                color='var(--content-primary-tertiary)'
              >
                Exclude these numbers from initiating new conversations in Smart Inbox
              </Typography>
            </Box>
            {shouldShowAddNumberFlow ? (
              <Button
                text='Add number'
                color='primary'
                onClick={handleAddNumbers}
                className={styles.addNumbersButton}
              />
            ) : (
              <SkipNumbers
                multiSelectedValues={multiSelectedValues}
                search={search}
                setSearch={setSearch}
                numbersGroups={numbersGroups}
                handleMultiSelect={handleMultiSelect}
                removeMultiSelectedItem={removeMultiSelectedItem}
                updateDeprioritizeNumbers={updateDeprioritizeNumbers}
              />
            )}
          </Box>
        </>
      )}
    </div>
  )
})
